import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ITimeLine, TIMELINE_STATUS } from '../../shared/model/timeline.dto';

@Injectable({
  providedIn: 'root'
})
export class SignUpTimelineService {
  private timeLineSteps = new BehaviorSubject<ITimeLine[]>(undefined);
  public timeLineActiveStep = this.timeLineSteps;

  private timeline: ITimeLine[] = TIMELINE_STATUS;

  constructor() {}

  public getDefaultTimeline(): ITimeLine[] {
    return [...this.timeline];
  }

  public markStepComplete(index: number): void {
    this.timeline.forEach((step, i) => {
      if (i < index) {
        step.isStepCompleted = true;
        step.isActive = false;
      } else if (i === index) {
        step.isStepCompleted = true;
        step.isActive = false;
      } else {
        step.isStepCompleted = false;
        step.isActive = false;
      }
    });

    // Activate the next step if it exists
    if (this.timeline[index + 1]) {
      this.timeline[index + 1].isActive = true;
    }
  }

  public setActiveStep(index: number): void {
    this.timeline.forEach((step, i) => (step.isActive = i === index));
  }
}
